export default function BoardLoading({ label }) {
  return (
    <main className="board-loading-shell" data-testid="board-loading-state">
      <div className="board-loading-mark" aria-hidden="true" />
      <p>{label}</p>
      <div className="board-loading-lines" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </main>
  );
}
